export class Widget {
  id: string;
  size: number[];

  constructor(widgetInfo: any) {
    this.id = widgetInfo.id;
    this.size = widgetInfo.size || [1, 1];
  }
}
